import { BannerNew } from "@components/banner";
import { ResizeContainer, styled } from "@sourceful/shared-components";
import { BannerInstance, ProductPreset } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";

export const Row = styled("div", {
  width: "100%",
  minHeight: toRem(400),
  display: "grid",
  variants: {
    inadequateSpace: {
      false: {
        gridTemplateColumns: `repeat(auto-fit, minmax(380px, 1fr))`,
      },
      true: {
        gridTemplateColumns: "1fr",
      },
    },
    hasGap: {
      true: {
        gridGap: "$inline_m1",
      },
    },
  },
});

interface BannerRowProps {
  banners: BannerInstance[];
  handlePresetSelect?: (preset: ProductPreset) => void;
  gridGap: boolean;
}

export const BannerRow = ({ banners, gridGap }: BannerRowProps) => {
  return (
    <ResizeContainer>
      {({ width }) => {
        if (width === undefined) {
          return null;
        }

        const inadequateSpace = width < 400;

        return (
          <Row hasGap={gridGap} inadequateSpace={inadequateSpace}>
            {banners.map(item => {
              return (
                <BannerNew
                  bannerInstance={item}
                  key={item._key}
                  appearance={gridGap ? "card" : "default"}
                />
              );
            })}
          </Row>
        );
      }}
    </ResizeContainer>
  );
};

export default BannerRow;
